import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateFirecracker extends PlayerState {

    anim: SpineGameObject;
    imgStartPos: Phaser.Math.Vector2;

    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.Firecracker);
    }

    beginState(): void {
        super.beginState();
        const anim = this.anim = this.scene.add.spine(0, 0, "powerup-firecracker-active", "active", false);
        anim.scale = 0.5;
        this.player.bgSpineContainer.add(anim);
        const bone = anim.findBone("character");
        this.imgStartPos = new Phaser.Math.Vector2(this.player.img.x, this.player.img.y);
        this.player.img.setPosition(bone.x / 2, -bone.y / 4);
        anim.once("complete", () => {
            anim.destroy();
            this.player.img.setPosition(0, 0);
            // this.player.evalFlight();
            this.player.emit(PlayerStateTypes.SmashThroughWall, true);
        });
    }

    shutDown(): void {
        this.anim.destroy();
        this.player.img.setPosition(this.imgStartPos.x, this.imgStartPos.y);
        super.shutDown();
    }

}